import { Table } from "@/features/Table";
import { type A9TimeSerie, columns } from "./columns";
import { type FilterA9TimeSeriesSchema, FilterA9TimeSeries } from "./filter";

const client = "a9";
const table_name = "a9_time_series";

export const A9TimeSeriesTable = () => {
  return (
    <Table<A9TimeSerie, FilterA9TimeSeriesSchema>
      label="Valorisation"
      client={client}
      table_name={table_name}
      columns={columns}
      filter={<FilterA9TimeSeries />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
